module.exports = {
  lang: {
    t1: `Trang chủ`,
    t2: `Thẻ danh tính`,
    t3: `Theo dõi`,
    t4: `Liên hệ`,
    t5: `Tin nhắn`,
    t6: `Đăng nhập`,
    t7: `Đăng ký`,
    t8: `Nền tảng kết nối thương mại toàn cầu mới, mảnh đất mới cho tiếp thị kỹ thuật số doanh nghiệp`,
    t9: `WeMeet - Đăng nhập bằng Số Điện thoại`,
    t10: `Số Điện thoại`,
    t11: `Mã xác nhận`,
    t12: `Vui lòng nhập số điện thoại của bạn`,
    t13: `Vui lòng nhập mã xác nhận`,
    t14: `Nhận`,
    t15: `Đăng nhập`,
    t16: `Vui lòng nhập số điện thoại đúng định dạng`,
    t17: `Mã xác nhận đã được gửi`,
    t18: `Mã xác nhận đã nhập không chính xác. Vui lòng kiểm tra và nhập lại.`,
    t19: `Đăng nhập thành công`,
    t20: `Mã xác nhận của bạn là (0). Vui lòng sử dụng trong vòng {1} phút.`,
    t21: `Hủy`,
    t22: `Xác nhận`,
    t23: `Chia sẻ hữu ích`,
    t24: `Tài khoản WeMeet của bạn chưa hoàn tất đăng ký. Hãy hành động ngay để hoàn thành quy trình đăng ký và tận hưởng nhiều tương tác đa dạng cùng những khả năng vô tận.`,
    t25: `Đi đến Đăng ký`,
    t26: `Đăng nhập WeMeet qua email`,
    t27: `Tên tài khoản`,
    t28: `Nhập địa chỉ email của bạn`,
    t29: `Mật khẩu`,
    t30: `Nhập mật khẩu của bạn`,
    t31: `Quên mật khẩu?`,
    t32: `Đăng nhập`,
    t33: `Các cách đăng nhập khác`,
    t34: `Đã đăng ký ứng dụng WeMeet Mini chưa? Sử dụng ngay.`,
    t35: `Đăng nhập với số điện thoại`,
    t36: `Hãy nhập email của bạn trước.`,
    t37: `Hãy nhập mật khẩu của bạn trước.`,
    t38: `Định dạng email không đúng`,
    t39: `Nếu bạn đã có tài khoản WeMeet, bạn có thể đăng nhập trực tiếp`,
    t40: `Đăng nhập`,
    t41: `Ảnh đại diện`,
    t42: `Vui lòng tải lên ảnh đại diện thật`,
    t43: `Họ và tên`,
    t44: `Tên đầu tiên`,
    t45: `Họ`,
    t46: `Tên tổ chức`,
    t47: `Xin vui lòng nhập tên tổ chức của quý vị`,
    t48: `Chức vụ`,
    t49: `Xin vui lòng nhập tên chức vụ của quý vị tại tổ chức đó`,
    t50: `Địa chỉ email`,
    t51: `Nhập địa chỉ email của bạn`,
    t52: `Số Điện thoại`,
    t53: `Vui lòng nhập số điện thoại của bạn`,
    t54: `Khu vực`,
    t55: `Xin vui lòng chọn khu vực`,
    t56: `Khu vực`,
    t57: `Xin vui lòng chọn tỉnh, thành phố, quận/huyện`,
    t58: `Địa chỉ`,
    t59: `Xin vui lòng nhập địa chỉ của quý vị`,
    t60: `Tôi đã đọc và đồng ý với`,
    t61: `Điều khoản dịch vụ`,
    t62: `Chính sách bảo mật`,
    t63: `Tiếp tục`,
    t64: `Xin vui lòng đánh dấu đồng ý với Thỏa thuận người dùng trước tiên`,
    t65: `Xin vui lòng nhập tên của quý vị`,
    t66: `Vui lòng điền họ`,
    t67: `Vui lòng điền email trước`,
    t68: `Vui lòng điền tên tổ chức trước`,
    t69: `Định dạng email không đúng`,
    t70: `Hủy`,
    t71: `Hoàn tất`,
    t72: `Xác minh số điện thoại di động`,
    t73: `Số Điện thoại`,
    t74: `Mã xác nhận`,
    t75: `Vui lòng nhập mã xác nhận`,
    t76: `Nhận`,
    t77: `Bỏ qua xác minh`,
    t78: `Gửi`,
    t79: `Đã xác minh`,
    t80: `Mã xác nhận đã nhập không chính xác. Vui lòng kiểm tra và nhập lại.`,
    t81: `Đã bỏ qua`,
    t82: `Chia sẻ hữu ích`,
    t83: `Số điện thoại bạn nhập đã được đăng ký với tài khoản WeMeet. Không cần đăng ký lại, vui lòng đăng nhập ngay.`,
    t84: `Đi đến trang đăng nhập`,
    t85: `Chia sẻ hữu ích`,
    t86: `Địa chỉ email bạn nhập đã được đăng ký với tài khoản WeMeet. Không cần đăng ký lại, vui lòng đăng nhập ngay.`,
    t87: `Đi đến trang đăng nhập`,
    t88: `Liên kết xác minh đã được gửi.`,
    t89: `Vui lòng kiểm tra hòm thư của bạn và bấm vào liên kết để hoàn tất đăng ký.`,
    t90: `Rồi`,
    t91: `Chào mừng đến với WeMeet`,
    t92: `Chào mừng đến với WeMeet! Hãy nhấn vào nút để hoàn tất đăng ký. Lưu ý thân thiện: Liên kết này có hiệu lực trong 24 giờ, hãy thực hiện ngay.`,
    t93: `Đăng ký thành công`,
    t94: `Email của bạn đã được kích hoạt. Vui lòng nhập mật khẩu.`,
    t95: `Nhập mật khẩu`,
    t96: `Nhập mật khẩu của bạn`,
    t97: `Xác nhận mật khẩu`,
    t98: `Vui lòng nhập lại mật khẩu`,
    t99: `Phải chứa sự kết hợp của chữ hoa, chữ thường, số và ký tự đặc biệt, có độ dài từ 8 đến 20 ký tự`,
    t100: `Nhập mật khẩu của bạn`,
    t101: `Vui lòng nhập lại mật khẩu`,
    t102: `Mật khẩu không khớp`,
    t103: `Chúc mừng bạn đã hoàn thành đăng ký`,
    t104: `Bạn đã đăng nhập vào WeMeet, bạn có thể tiếp tục các hành động trước đó của mình`,
    t105: `Tiếp tục trải nghiệm của bạn`,
    t106: `Chia sẻ hữu ích`,
    t107: `Liên kết đã hết hạn. Hãy bấm vào nút để lấy lại.`,
    t108: `Gửi lại`,
    t109: `Điều khoản dịch vụ`,
    t110: `Chính sách bảo mật`,
    t111: `Khôi phục mật khẩu`,
    t112: `Vui lòng nhập tài khoản mà bạn muốn khôi phục mật khẩu`,
    t113: `Tên tài khoản`,
    t114: `Nhập địa chỉ email của bạn`,
    t115: `Gửi`,
    t116: `Hãy nhập email của bạn trước.`,
    t117: `Định dạng email không đúng`,
    t118: `Email đã được gửi`,
    t119: `Vui lòng kiểm tra hòm thư của bạn, bấm vào liên kết và đặt lại mật khẩu.`,
    t120: `Rồi`,
    t121: `Đặt lại mật khẩu - WeMeet`,
    t122: `Yêu cầu đặt lại mật khẩu của bạn đã được xác nhận, và hệ thống đã tạo một liên kết đặt lại mật khẩu tạm thời. Lưu ý thân thiện: Liên kết này có hiệu lực trong 24 giờ, hãy thực hiện ngay.`,
    t123: `Đặt lại mật khẩu`,
    t124: `Đặt lại mật khẩu thành công`,
    t125: `Bạn đã đăng nhập vào WeMeet. Chào mừng trở lại.`,
    t126: `Truy cập trang chủ`,
    t127: `Liên hệ`,
    t128: `Yêu cầu thêm bạn mới`,
    t129: `Đồng ý`,
    t130: `Bỏ qua`,
    t131: `Đã đồng ý`,
    t132: `Đã bỏ qua`,
    t133: `Đang theo`,
    t134: `Đang được theo dõi`,
    t135: `Tin nhắn`,
    t136: `Yêu cầu chưa được xử lý`,
    t137: `Vui lòng nhập họ tên hoặc số điện thoại`,
    t138: `Không tìm thấy nội dung phù hợp`,
    t139: `Không còn nữa đâu`,
    t140: `Yêu cầu liên hệ`,
    t141: `Đồng ý`,
    t142: `Bỏ qua`,
    t143: `Đã đồng ý`,
    t144: `Đã bỏ qua`,
    t145: `Không gian WeMeet AI`,
    t146: `Đang theo dõi`,
    t147: `Đã hủy theo dõi`,
    t148: `vCard`,
    t149: `Kết nối`,
    t150: `Gửi tin nhắn`,
    t151: `Chờ duyệt`,
    t152: `Xóa liên hệ`,
    t153: `Giới thiệu bản thân`,
    t154: `Hồ sơ cá nhân`,
    t155: `Chia sẻ hữu ích`,
    t156: `Yêu cầu liên hệ của bạn đã được gửi đi. Sau khi được chấp thuận, bạn sẽ tự động theo dõi người đó. Bạn cũng có thể chọn theo dõi người đó ngay lập tức để biết thêm thông tin.`,
    t157: `Chưa theo dõi`,
    t158: `Theo dõi`,
    t159: `Đang theo dõi`,
    t160: `Xóa mối quan hệ người dùng`,
    t161: `Sau khi xóa mối quan hệ người dùng, người đó sẽ không còn thể xem thông tin cá nhân của bạn nữa, nhưng họ sẽ không đồng thời hủy theo dõi bạn.`,
    t162: `Hãy suy nghĩ lại`,
    t163: `Xóa liên hệ`,
    t164: `Thao tác thành công`,
    t165: `Trợ lý AI WeMeet`,
    t166: `Hãy nhập câu hỏi của bạn`,
    t167: `Gửi`,
    t168: `Lưu ý nội dung tương tác với AI có thể không chính xác và không đại diện cho quan điểm của nền tảng.`,
    t169: `Thẻ danh thiếp WeMeet`,
    t170: `Tải xuống`,
    t171: `Chỉnh sửa thẻ danh thiếp`,
    t172: `Tải mã QR`,
    t173: `Hình ảnh đã được tạo. Vui lòng lưu lại. Quét mã QR để lưu thông tin liên lạc.`,
    t174: `Ảnh đại diện`,
    t175: `Vui lòng tải lên ảnh đại diện thật`,
    t176: `Họ và tên`,
    t177: `Tên đầu tiên`,
    t178: `Họ`,
    t179: `Hãy nhập tên của bạn`,
    t180: `Tên tổ chức`,
    t181: `Xin vui lòng nhập tên tổ chức của quý vị`,
    t182: `Chức vụ`,
    t183: `Xin vui lòng nhập tên chức vụ của quý vị tại tổ chức đó`,
    t184: `Địa chỉ email`,
    t185: `Nhập địa chỉ email của bạn`,
    t186: `Số Điện thoại`,
    t187: `Vui lòng nhập số điện thoại của bạn`,
    t188: `Vùng`,
    t189: `Xin vui lòng chọn khu vực`,
    t190: `Khu vực`,
    t191: `Xin vui lòng chọn tỉnh, thành phố, quận/huyện`,
    t192: `Địa chỉ`,
    t193: `Xin vui lòng nhập địa chỉ của quý vị`,
    t194: `Xin vui lòng nhập tên của quý vị`,
    t195: `Vui lòng điền họ`,
    t196: `Vui lòng điền email trước`,
    t197: `Vui lòng điền tên tổ chức trước`,
    t198: `Định dạng email không đúng`,
    t199: `Phòng trò chuyện`,
    t200: `Thư viện ảnh`,
    t201: `Chụp ảnh`,
    t202: `Hãy nhập tin nhắn của bạn`,
    t203: `Gửi`,
    t204: `Đã đọc`,
    t205: `Chưa đọc`,
    t206: `Hết hạn rút lại`,
    t207: `Hủy`,
    t208: `Ảnh`,
    t209: `Album`,
    t210: `Chụp ảnh`,
    t211: `Chọn từ Album`,
    t212: `Hủy`,
    t213: `Ảnh`,
    t214: `Chân dung`,
    t215: `Xem trước`,
    t216: `Hoàn tất`,
    t217: `Không gian WeMeet AI`,
    t218: `Liên hệ với chúng tôi`,
    t219: `Hãy liên hệ với tôi`,
    t220: `Họ và tên`,
    t221: `Tổ chức`,
    t222: `Chức vụ`,
    t223: `Điện thoại`,
    t224: `Địa chỉ email`,
    t225: `Khu vực`,
    t226: `Khu vực`,
    t227: `Địa chỉ`,
    t228: `Vui lòng nhập họ và tên của bạn`,
    t229: `Vui lòng điền tên tổ chức của quý vị`,
    t230: `Vui lòng điền chức vụ của quý vị`,
    t231: `Vui lòng nhập số điện thoại của bạn`,
    t232: `Vui lòng điền địa chỉ email của quý vị`,
    t233: `Xin vui lòng chọn khu vực`,
    t234: `Xin vui lòng chọn tỉnh, thành phố, quận/huyện`,
    t235: `Vui lòng nhập địa chỉ`,
    t236: `Ý định`,
    t237: `Mua sản phẩm`,
    t238: `Sản phẩm đại lý`,
    t239: `Hợp tác thị trường`,
    t240: `Khác`,
    t241: `Vui lòng nhập họ và tên của bạn`,
    t242: `Vui lòng điền tên tổ chức của quý vị`,
    t243: `Vui lòng điền địa chỉ email của quý vị`,
    t244: `Định dạng email không đúng`,
    t245: `Tin nhắn đã được gửi`,
    t246: `Để lại tin nhắn`,
    t247: `Vui lòng nhập nội dung câu hỏi của bạn`,
    t248: `Xác nhận`,
    t249: `Vui lòng đăng nhập hoặc đăng ký trước`,
    t250: `Người theo dõi`,
    t251: `Liên hệ với chúng tôi`,
    t252: `Sản phẩm`,
    t253: `Đội ngũ`,
    t254: `Tóm tắt tổng quan`,
    t255: `Album`,
    t256: `Chứng nhận`,
    t257: `Vốn điều lệ`,
    t258: `Ngày thành lập`,
    t259: `Địa chỉ đăng ký`,
    t260: `Đầu nguồn`,
    t261: `Trung lưu`,
    t262: `Hạ lưu`,
    t263: `Verbundene Branchen`,
    t264: `Quy trình`,
    t265: `Lưu`,
    t266: `Đã xác minh`,
    t267: `Trung Quốc`,
    t268: `Tiếng Anh`,
    t269: `Tiếng Pháp`,
    t270: `Tiếng Nga`,
    t271: `Tiếng Tây Ban Nha`,
    t272: `Tiếng Nhật`,
    t273: `Tiếng Hàn`,
    t274: `Tiếng Indonesia`,
    t275: `Tiếng Việt`,
    t276: `Tiếng Đức`,
    t277: `Tiếng Thổ Nhĩ Kỳ`,
    t278: `Tiếng Ý`,
    t279: `Tiếng Bồ Đào Nha`,
    t280: `Tiếng Thái`,
    t281: `Tiếng Mã Lai`,
    t282: `Tiếng Ả Rập`,
    t283: `Tên đăng nhập hoặc mật khẩu không đúng`,
    t284: `Vui lòng đọc và chấp nhận Thỏa thuận người dùng WeMeet trước khi tiếp tục`,
    t285: `Chưa có nội dung liên quan`,
    t286: `Loại`,
    t287: `Thuộc tính`,
    t288: `Chi tiết`,
    t289: `Khác`,
    t290: `Tổng cộng 2 sản phẩm`,
    t291: `{1} mời bạn đến thăm WeMeet AI Space của {2}`,
    t292: `Nhấn vào đây để xem một ví dụ hoặc nhập một câu hỏi:`,
    t293: `Làm mới`,
    t294: `Bạn cũng có thể nhấp vào danh thiếp bên dưới để thêm liên hệ và biết thêm thông tin:`,
    t295: `Tìm hiểu`,
    t296: `Họp số WeMeet`,
    t297: `Triển lãm số WeMeet`,
    t298: `Kartu nama dan Ruang AI WeMeet`,
    t299: `Làm thế nào để trở thành thành viên tổ chức WeMeet`,
    t300: `Dịch vụ Hội nghị Kỹ thuật số WeMeet cung cấp cho bạn một giải pháp họp trực tuyến toàn diện, bao gồm nhưng không giới hạn trong việc tạo và công bố cuộc họp, quản lý đăng ký người tham gia, check-in điện tử, lập lịch cuộc họp, chia sẻ tài liệu họp, thảo luận tương tác thời gian thực và tương tác với khách mời.`,
    t301: `WeMeet Số Hóa Triển Lãm, giúp xây dựng nhanh chóng trang web chính thức triển lãm micro. Hiển thị thông tin người trưng bày, giới thiệu hàng hóa trưng bày, trực tiếp trình chiếu triển lãm, đăng ký tham gia triển lãm, lịch trình sự kiện, và nhiều hơn nữa, giúp các doanh nghiệp tham gia và khán giả dễ dàng hiểu rõ chi tiết triển lãm. Để sử dụng chức năng WeMeet Số Hóa Triển Lãm, vui lòng hoàn tất quá trình nhập cư trước. Nhấn vào "Của tôi", cuộn xuống "Trung tâm Dịch vụ" - "Nhập cư" và làm theo hướng dẫn để hoàn tất quá trình nhập cư.`,
    t302: `Người dùng cá nhân của WeMeet chỉ cần ủy quyền ID WeChat, số điện thoại và hoàn tất đăng ký trên nền tảng để nhận thẻ danh thiếp số cá nhân và duy trì Phòng chờ AI cá nhân (bao gồm hồ sơ cá nhân, cập nhật, ảnh, tài liệu, v.v.).`,
    t303: `Nhấn vào tùy chọn "Của tôi" trên thanh menu dưới cùng của mini-program để cập nhật trang danh thiếp cá nhân và cải thiện trang chủ cá nhân.`,
    t304: `Kết hợp chữ in hoa và chữ thường, số và dấu câu, độ dài từ 8-20 ký tự.`,
    t305: `Nhập tên sản phẩm`,
    t306: `Không còn nữa`,
    t307: `Nhấp vào góc phải trên`,
    t308: `Chọn cách chia sẻ mà bạn thích`,
    t309: `Tôi hiểu`,
    t310: `Vui lòng hoàn tất đăng ký và đăng nhập trước`,
    t311: `Tìm hiểu thêm`,
    t312: `Sản phẩm liên quan`,
    t313: `Cảm ơn bạn đã ghé thăm`,
    t314: `Đăng xuất`,
    t315: `Tổ chức đã theo dõi`,
    t316: `Trang trước`,
    t317: `Trang tiếp`,
    t318: `Không có`,
    t319: `{1} mời bạn ghé thăm {2}`,
    t320: `Phòng AI chưa bảo trì ngôn ngữ hiện tại`,
    t321: `Phòng AI đã chuyển sang ngôn ngữ hiện tại`,
    t322: `Liên kết đã được kích hoạt`,
    t323: `Mạng bận rộ, vui lòng thử lại sau`,
    t324: `Chi tiết sản phẩm đã chuyển sang ngôn ngữ hiện tại`,
    t325: `Chi tiết sản phẩm hiện không được duy trì trong ngôn ngữ này`,
    t326: `Chào bạn, tôi là trợ lý trí tuệ WeMeet, sẵn sàng cung cấp dịch vụ chu đáo cho bạn bất cứ lúc nào! Tôi có thể giúp gì cho bạn?`,
    t327: `Nhập tên`,
    t328: `Tôi đã tìm thấy thông tin liên hệ liên quan, vui lòng kiểm tra thẻ liên hệ bên dưới.`,
    t329: `Tệp đính kèm`,
    t330: `Tôi không tìm thấy thông tin liên lạc liên quan.`,
    t331: `Tôi đã chuyển yêu cầu của bạn cho đồng nghiệp phụ trách bên dưới; bạn cũng có thể nhấp vào danh thiếp để liên hệ ngay lập tức.`,
    t332: `Triển lãm`,
    t333: `Vui lòng nhập`,
    t334: `Người dùng`,
    t335: `Không còn nữa`,
    t336: `Làm mới thành công`,
    t337: `Đang tải`,
    t338: `Thả để làm mới`,
  },
};
// 越南语
